var NotificationSubject = {
  MERCURIAL_DELETE_OR_UPDATE: 0,
  RENTAL_CONFIRMATION: 1,
  RENTAL_ACCEPTED: 2,
  RENTAL_DATE_CHANGED_BY_CLIENT: 3,
  RENTAL_DATE_CHANGED_BY_ADMIN: 4,
  RENTAL_CANCELLED: 5,
};

module.exports = NotificationSubject;
